import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-club-dashboard-coach',
  templateUrl: './club-dashboard-coach.component.html',
  styleUrls: ['./club-dashboard-coach.component.css']
})
export class ClubDashboardCoachComponent implements OnInit {

  coachForm: FormGroup;
  id: number;
  countryData: any = {};
  clubData: any = {};
  searchText: any;
  currentUser: any;
  isLoaderVisible = false;
  submitted = false;
  isSubmitted = true;
  clubId: number;
  countryName: string;
  errorMessage: string = '';


  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastrService: ToastrService,

  ) { }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.route.queryParams.subscribe(params => this.id = params.id);
    this.getClubProfile();
    this.coachForm = this.formBuilder.group({
      clubId: [this.id],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      coachAvatar: ['', Validators.required],
      createdBy: [this.currentUser.success.user.id],
    });

  }
  getClubProfile() {
    this.isLoaderVisible = true;
    const data = {
      clubId: this.id,
    };
    this.iffhsService.getClubProfile(data).subscribe((res: any) => {
      this.clubData = res.club;
      this.countryData = res.country;
      this.isLoaderVisible = false;
    });
  }
  onFileSelect(event) {
    const coachAvatar = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/image\/*/) === null) {
      this.toastrService.error('Only images are supported', 'Message!');
      return;
    }
    this.coachForm.get('coachAvatar').setValue(coachAvatar);

  }
  get f() { return this.coachForm.controls; }
  addCoach() {
    this.submitted = true;
    if (this.coachForm.invalid) {
      return;
    }
    this.isLoaderVisible = true;
    const fd = new FormData();
    fd.append('clubId', this.coachForm.get('clubId').value);
    fd.append('firstName', this.coachForm.get('firstName').value);
    fd.append('lastName', this.coachForm.get('lastName').value);
    fd.append('createdBy', this.coachForm.get('createdBy').value);
    fd.append('coachAvatar', this.coachForm.get('coachAvatar').value);
    this.iffhsService.addCoach(fd).pipe(first()).subscribe(
      data => {
        this.isLoaderVisible = false;
        this.submitted = true;
        this.toastrService.success('Coach Added!', 'Message!');

      },
      error => {
        console.log(error);
        this.isLoaderVisible = false;
        this.toastrService.error('Something went wrong please Try Again Later!', 'Message!');

      }
    );
    this.coachForm = this.formBuilder.group({
      clubId: [this.id],
      firstName: [null],
      lastName: [null],
      coachAvatar: [null],
      createdBy: [this.currentUser.success.user.id],
    });


  }

}
